/**
 * Class for general child theme functions.
 *
 * @class      Theming (name)
 */
export class Theming
{
	/**
	 * Boots up the app using all so far defined init functions.
	 *
	 * @param      {object}  functionReference  List of functions to run or object of namespaces
	 */
	static initApp( functionReference = window.app.init )
	{
		// Run parent theme functions
		for ( let init in functionReference )
		{
			// Is this a function?
			if ( typeof functionReference[ init ] === 'function' )
			{
				// Run the function
				functionReference[ init ]();
			}
			// Is it an object (i.e. nested namespace)
			else if ( typeof functionReference[ init ] === 'object' )
			{
				// Go recursive until we're done
				Theming.initApp( functionReference[ init ] );
			}
		}
	}
}
